<template>
    <div>
        <el-form label-position="right" style="width: 600px;">
            <el-form-item label="产品ID" label-width="150px">
                <el-input v-model="data.id" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="是否为主险" label-width="150px">
                <el-input :value="getValue(data.main)" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="是否已发布" label-width="150px">
                <el-input :value="getValue(data.published)" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="产品类型" label-width="150px">
                <el-input :value="typeStr[data.type]" disabled="disabled"></el-input>
            </el-form-item>
            <div class="txt">基本信息</div>
            <div>
                <el-form-item label="产品名称：" label-width="150px">
                    <el-input v-model="data.basicInfo.name" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="产品合同名：" label-width="150px">
                    <el-input v-model="data.basicInfo.contractName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="产品别名：" label-width="150px">
                    <el-input disabled="disabled" v-for="item in data.basicInfo.alias" :value="item"></el-input>
                </el-form-item>
                <el-form-item label="产品卖点：" label-width="150px">
                    <textarea v-model="data.basicInfo.sellingPoints" disabled="disabled" style="width: 450px;"></textarea>
                </el-form-item>
                <el-form-item label="产品描述：" label-width="150px">
                    <el-input disabled="disabled" v-for="item in data.basicInfo.description" :value="item"></el-input>
                </el-form-item>
                <el-form-item label="保险公司：" label-width="150px">
                    <el-input disabled="disabled" :value="getCompanyName(data.basicInfo.companyId)"></el-input>
                </el-form-item>
                <el-form-item label="产品标签：" label-width="150px">
                    <el-input disabled="disabled" v-for="item in data.basicInfo.tags" :value="item"></el-input>
                </el-form-item>
                <el-form-item label="等待期(天)：" label-width="150px">
                    <el-input v-model="data.basicInfo.waitingPeriod" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="犹豫期(天)：" label-width="150px">
                    <el-input v-model="data.basicInfo.coolingOffPeriod" disabled="disabled"></el-input>
                </el-form-item>
            </div>
            <div class="txt">投保要求</div>
            <div>
                <el-form-item label="角色：" label-width="150px">
                    <el-input v-model="role[data.requirement.role]" disabled="disabled"></el-input>
                </el-form-item>
<!--                <el-form-item label="投保条件至少几项：" label-width="150px">
                    <el-input v-model="data.requirement.conditionSet.min" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="投保条件至多几项：" label-width="150px">
                    <el-input v-model="data.requirement.conditionSet.max" disabled="disabled"></el-input>
                </el-form-item>-->
                <el-form-item label="年龄要求：" label-width="150px">
                    <template>
                        <span>最小值</span>
                        <el-form inline>
                            <el-form-item v-for="(value, key) in data.requirement.conditionSet.conditions[0].params.min" v-if="key !== 'age'" label-width="50px" :label="labelAgeText(key)">
                                <el-input  :value="value" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-form>
                        <span>最大值</span>
                        <el-form inline>
                            <el-form-item v-for="(value, key) in data.requirement.conditionSet.conditions[0].params.max" v-if="key !== 'age'" label-width="50px" :label="labelAgeText(key)">
                                <el-input  :value="value" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-form-item>
                <el-form-item label="职业要求：" label-width="150px">
                    <template>
                        <el-select v-model="data.requirement.conditionSet.conditions[1].params.occupations" multiple placeholder="请选择" size="small" disabled="disabled">
                            <el-option
                                v-for="item in conditionOccupationOptions"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code">
                            </el-option>
                        </el-select>
                    </template>
                </el-form-item>
            </div>
            <div class="txt">保障期限</div>
            <div>
                <el-form-item label-width="100px" v-for="(v, i) in data.validPeriodOptions" :label="validPeriodText(v)">
                    <el-form>
                        <el-form-item v-for="(value, key) in v" v-if="key === 'year'" label-width="50px" :label="labelText(key)">
                            <el-input  :value="value" disabled="disabled"></el-input>
                        </el-form-item>
                    </el-form>
                </el-form-item>
            </div>
            
            <div class="txt">保额</div>
            <div v-if="data.amount">
                <div v-if="data.amount.range">
                    <el-form-item label-width="150px" label="区间最小值(万元):">
                        <el-input  :value="(data.amount.options[0]/1E6).toFixed(2)" disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label-width="150px" label="区间最大值(万元):">
                        <el-input  :value="(data.amount.options[1]/1E6).toFixed(2)" disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label-width="150px" label="按多少递增(元):">
                        <el-input  :value="(data.amount.step/100).toFixed(2)" disabled="disabled"></el-input>
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label-width="150px" label="保额(万元):" v-for="(v, i) in data.amount.options" :key="i">
                        <el-input  :value="(v/1E6).toFixed(2)" disabled="disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            
            
            <div class="txt">交费方式</div>
            <div>
                <el-form-item label-width="100px" v-for="(v, i) in data.payMethodOptions" :label="payMethodText(v.type)">
                    <template>
                        <el-form inline v-if="v.type === 'payAnnually'">
                            <el-form-item label="至XX岁" label-width="80px" v-if="v.params.age">
                                <el-input :value="v.params.year" disabled="disabled" style="width: 100px;"></el-input>
                            </el-form-item>
                            <el-form-item label="交XX年" label-width="80px" v-else>
                                <el-input :value="v.params.year" disabled="disabled" style="width: 100px;"></el-input>
                            </el-form-item>
                            <el-form-item label="是否支持按月交">
                                <el-input :value="payMonthlyText(v.params.payMonthly)" disabled="disabled" style="width: 100px;"></el-input>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>
<script>
import request from "@/api/request";

export default {
    props: {
        type: String,
        data: Object
    },
    data(){
        return {
            companyOptions: [],
            role: ['投保人','被保人'],
            typeStr: {
                0:"医疗险",
                1:"重疾险",
                2:"寿险",
                3:"意外险"
            },
            conditionOccupationOptions: [{"code":1,"name":"1类职业"},{"code":2,"name":"2类职业"},{"code":3,"name":"3类职业"},{"code":4,"name":"4类职业"},{"code":5,"name":"5类职业"},{"code":6,"name":"6类职业"}],
        }
    },
    mounted() {
        this.getCompanyOptions()
    },
    methods: {
        labelAgeText(key){
            return key === 'day' ? '天' : key === 'month' ? '月' : '岁'
        },
        labelText(key){
            return key === 'day' ? '天' : key === 'month' ? '月' : '年'
        },
        validPeriodText(v){
            return v.age && v.year === 999 ? '终身' : v.age ? '至XX岁' : '保XX年'
        },
        payMethodText(t){
            return t === 'payInFull' ? '趸交' : '年交'
        },
        payMonthlyText(t){
            return t ? '支持' : '不支持'
        },
        getValue(t){
            return t ? '是' : '否'
        },
        getCompanyOptions(){
            request.product
                .post(
                    'company_list',
                    {
                        range: [0,1000]
                    }
                )
                .then(res => {
                    this.companyOptions = res.data.list
                })
        },
        getCompanyName(id){
            let name
            this.companyOptions.forEach(i => {
                if(i.id === id){
                    name = i.name
                }
            })
            return name
        },
    }
}
</script>
<style scoped>
.txt{
    font-size: 16px;
    font-weight: 500;
}
</style>
